(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.megaheader = window.oneadvanced.megaheader || {};
    window.oneadvanced.megaheader.init = function () {

        // When hovering on LI in the nav, remove the grey underline of the previous LI
        document.querySelectorAll('li.opens-right ul.menu').forEach((ul) => {
            const liItems = ul.querySelectorAll('li.is-dropdown-submenu-item');

            liItems.forEach((li) => {
                li.addEventListener('mouseover', () => {
                    const previousSibling = li.previousElementSibling;

                    if (previousSibling) {
                        const previousSiblingLink = previousSibling.querySelector("a");
                        if (previousSiblingLink) {
                            previousSiblingLink.classList.add('no-underline');
                        }
                    }
                });

                li.addEventListener('mouseout', () => {
                    const previousSibling = li.previousElementSibling;

                    if (previousSibling) {
                        const previousSiblingLink = previousSibling.querySelector("a");
                        if (previousSiblingLink) {
                            previousSiblingLink.classList.remove('no-underline');
                        }
                    }
                });
            });
        });

        /**
         * Adjusts the maximum width of the dropdown menu based on the number of items in the second column.
         * If there are 9 or fewer items, it sets the maximum width to 800px and displays them in one column.
         * If there are more than 9 items, it removes the max width restriction and displays them in two columns.
         * It only runs this logic if any item in the first column has the .is-active class.
         * 
         * @param {HTMLElement} a - The element that triggered the width adjustment.
         */
        function adjustMaxWidth(a) {
            var parentLi = $(a).closest('li.is-dropdown-submenu-parent');
            var secondColumn = parentLi.find('ul.menu.second-column');
            var firstSubElement = parentLi.closest('ul.menu.submenu.first-sub');
            var firstSubElementDOM = firstSubElement.get(0);
            var firstColumnItems = firstSubElement.find('> li');

            // function to adjust the max width based on the number of items
            function adjustWidth() {
                var secondColumnItems = secondColumn.find('li');

                if (secondColumnItems.length <= 9) {
                    firstSubElementDOM.style.maxWidth = '800px';
                    secondColumn.addClass('one-column');
                    secondColumn.removeClass('two-columns');
                } else {
                    firstSubElementDOM.style.maxWidth = 'unset';
                    secondColumn.addClass('two-columns');
                    secondColumn.removeClass('one-column');
                }
            }

            // function to reset the width if no active items are found
            function resetWidth() {
                firstSubElementDOM.style.maxWidth = '800px';
                secondColumn.removeClass('two-columns'); // reset classes if needed
                //console.log("Width reset because no active items found.");
            }

            // set up the observer to check for active items in the first column
            var observer = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    // check if the class attribute has changed and if .is-active was added
                    if (
                        mutation.type === 'attributes' &&
                        mutation.attributeName === 'class'
                    ) {
                        // run adjustWidth only if there's an active item
                        if (firstColumnItems.filter('.is-active').length > 0) {
                            adjustWidth(); // adjust width if there's an active item
                        } else {
                            resetWidth(); // reset width if no active items are found
                        }
                        break; // only need to run once per mutation
                    }
                }
            });

            // start observing each item in the first column for changes
            firstColumnItems.each(function () {
                observer.observe(this, { attributes: true });
            });
        }


        /**
         * Adjusts the height of the dropdown navigation based on the items in the first and second columns.
         * The height is determined by the number of items in the first column that have the .is-active class.
         * If an item is active, it counts the items in the second column. otherwise, it sets that count to zero.
         * The maximum height is capped at 532 pixels to fit 10 first column items max.
         *
         * @param {HTMLElement} a - The element that triggered the height adjustment.
         */
        function adjustHeight(a) {
            var parentLi = $(a).closest('li.is-dropdown-submenu-parent');
            var secondColumn = parentLi.find('ul.menu.second-column');
            var maxHeight = 532;
            var firstSubElement;

            // check if the parent <li> has the specific classes
            if (parentLi.hasClass('menu-item is-dropdown-submenu-parent opens-right')) {
                firstSubElement = parentLi.find('ul.menu.submenu.first-sub.is-dropdown-submenu');
            } else {
                firstSubElement = parentLi.closest('ul.menu.submenu.first-sub.is-dropdown-submenu');
            }

            var firstSubElementDOM = firstSubElement.get(0);
            var firstColumnItems = firstSubElement.find('> li');

            // update the height if any item in the first column is active
            function updateHeight() {
                // check if any item in the first column has the .is-active class
                var hasActiveItem = firstColumnItems.filter('.is-active').length > 0;
                //console.log("hasActiveItem is - ", hasActiveItem);

                // only count the items in the second column if there’s an active item
                var numberOfSecondColumnItems = hasActiveItem ? secondColumn.find('li').length : 0;
                //console.log("firstColumnItems is - ", firstColumnItems);
                //console.log("numberOfSecondColumnItems is - ", numberOfSecondColumnItems);

                // count how many items are in the first column
                var numberOfFirstColumnItems = firstColumnItems.length;
                //console.log("numberOfFirstColumnItems is - ", numberOfFirstColumnItems);

                // calculate the height based on item count, each item is 50px high plus some padding
                var firstColumnHeight = numberOfFirstColumnItems * 50 + 32;
                var secondColumnHeight = numberOfSecondColumnItems * 52 + 32;
                //console.log("firstColumnHeight is - ", firstColumnHeight);
                //console.log("secondColumnHeight is - ", secondColumnHeight);

                // get the height based on which column has more items
                var totalHeight = Math.max(firstColumnHeight, secondColumnHeight);

                // don’t let the height exceed the max limit
                if (totalHeight > maxHeight) {
                    totalHeight = maxHeight;
                }

                firstSubElementDOM.style.height = totalHeight + 'px';
                //console.log("Height adjusted to:", totalHeight);
            }

            // set up the observer to watch for when the .is-active class is added
            var observer = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    if (
                        mutation.type === 'attributes' &&
                        mutation.attributeName === 'class' &&
                        $(mutation.target).hasClass('is-active')
                    ) {
                        updateHeight();
                        break;
                    }
                }
            });

            // observing each item in the first column
            firstColumnItems.each(function () {
                observer.observe(this, { attributes: true });
            });

            updateHeight();
        }

        // reset nav dropdown width when nothing is opened to prevent kept state with wide width from before
        function resetMaxWidth(a) {
            var parentLi = $(a).closest('li.is-dropdown-submenu-parent');
            var firstSubUL = parentLi.find('ul.menu.submenu.first-sub');
            var childLIs = firstSubUL.find('li.menu-item.is-submenu-item.is-dropdown-submenu-item');
            var secondColumnOpen = false;

            childLIs.each(function () {
                $(this).on('click', function (event) {
                    event.preventDefault();
                    var childLiDOM = $(this).get(0);

                    // Check if the first-sub menu is active
                    if (childLiDOM) {
                        var $childLi = $(childLiDOM);
                        if ($childLi.hasClass('js-dropdown-active')) {
                            secondColumnOpen = true;
                        }
                    }
                });
            });

            if (!secondColumnOpen) {
                var firstSubULDOM = firstSubUL.get(0);
                firstSubULDOM.style.maxWidth = '800px';
            } else {
                return;
            }
        }

        // Add event listeners to the nav items to run the width adjustment
        var firstSubLinks = $('ul.menu.submenu.first-sub > li > a');
        firstSubLinks.each(function () {
            $(this).on('click', function (event) {
                var link = $(this);
                var parentLi = link.closest('li');
                var hasChildren = parentLi.find('ul').length > 0;
                var isFirstChildOfDropdownParent = parentLi.prev('li.is-dropdown-submenu-parent').length === 0;
                event.preventDefault();
                adjustMaxWidth(this);
                adjustHeight(this);

                if (parentLi.has(link).length) {
                    // Redirect only if the link has no children, and is not the first child of a dropdown parent
                    if (!hasChildren && !isFirstChildOfDropdownParent) {
                        window.location = link.attr('href');
                    }
                }
            });

            $(this).closest('li').on('click', function (event) {
                var link = $(this).find('a');
                var hasChildren = $(this).find('ul').length > 0; // Check if the list item has a submenu

                if (!hasChildren) {
                    window.location = link.attr('href');
                }
            });
        });

        var topLevelLinks = $('ul.vertical.large-horizontal.menu.dropdown > li.menu-item.is-dropdown-submenu-parent.opens-right > a');
        topLevelLinks.each(function () {
            $(this).on('click', function (event) {
                event.preventDefault();
                resetMaxWidth(this);
                adjustHeight(this);
            });
        });

        // handle all anchor tags inside .second-column
        var secondColumnAnchors = $('.main-navigation .second-column a');
        secondColumnAnchors.each(function () {
            $(this).on('click', function (event) {
                window.location = $(this).attr('href');
            });
        });

        // handle clicks on the <li> elements inside .second-column to redirect to the child anchor link
        $('.main-navigation .second-column li').each(function () {
            $(this).on('click', function (event) {
                var link = $(this).find('a');
                if (link.length > 0) {
                    window.location = link.attr('href');
                }
            });
        });

        document.addEventListener("DOMContentLoaded", function (event) {
            window.oneadvanced.megaheader.navigation = document.getElementById("navigation");
            if (window.oneadvanced.megaheader.navigation) {
                window.oneadvanced.megaheader.firstNested = Array.from(nav.querySelectorAll('.first-sub > li.is-dropdown-submenu-parent'));
                window.oneadvanced.megaheader.firstNested.forEach(function (htmlElement) {
                    window.oneadvanced.megaheader.navLevels = Array.from(htmlElement.getElementsByClassName("submenu"));
                    if (window.oneadvanced.megaheader.navLevels.length > 1) {
                        htmlElement.classList.add('multi-level-menu');
                    } else {
                        htmlElement.classList.add('singular-menu');
                    }
                })
            }
        });

        window.oneadvanced.megaheader.modal = document.getElementById('meganavigation__modal');

        //function to adjust margin-top value on main when minimal nav option is selected
        function adjustMainMarginTop(value) {
            var mainElement = document.getElementById('main');
            mainElement.style.marginTop = value;
        }

        //var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        //var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        function handleBlurScrollDown() {
            if (window.innerWidth <= 991) {
                // load mobile script

                var subMenuItems = $("#navigation > div > ul > li > ul.submenu");
                subMenuItems.each(function (idx, subMenu) {
                    var selectedSubMenu = $(subMenu);
                    //If any one of submenu is open show the header navbar
                    if (selectedSubMenu.hasClass("visible")) {
                        $('#headerNavbar').show();
                        window.oneadvanced.megaheader.modal.classList.add('is-active');
                        return false;
                    }
                    //If none of submenu is open show the header navbar
                    else {
                        $('#preHeaderNavbar').removeClass('hidden');
                    }
                });
            }
            else {
                // load desktop script
                $('#navigation > ul').show();
                var firstSubMenuItems = $("#navigation > ul > li > ul.first-sub");
                firstSubMenuItems.each(function (idx, firstSubMenu) {
                    var selectedfirstSubMenu = $(firstSubMenu);
                    if (selectedfirstSubMenu.hasClass("js-dropdown-active")) {
                        window.oneadvanced.megaheader.modal.classList.add('is-active');
                        return false;
                    }
                });
            }
        }

        function handleBlurScrollUp() {
            if (window.innerWidth <= 991) {
                // load mobile script
                $('#headerNavbar').hide();
                window.oneadvanced.megaheader.modal.classList.remove('is-active');
            }
            else {
                // load desktop script
                $('#navigation > ul').hide();
                window.oneadvanced.megaheader.modal.classList.remove('is-active');
            }
        }

        (function () {

            var doc = document.documentElement;
            var w = window;

            /*
            define four variables: curScroll, prevScroll, curDirection, prevDirection
            */

            var curScroll;
            var prevScroll = w.scrollY || doc.scrollTop;
            var curDirection = 0;
            var prevDirection = 0;

            var lastY = 0;

            /*
            how it works:
            -------------
            create a scroll event listener
            create function to check scroll position on each scroll event,
            compare curScroll and prevScroll values to find the scroll direction
            scroll up - 1, scroll down - 2, initial - 0
            then set the direction value to curDirection
            compare curDirection and prevDirection
            if it is different, call a function to show or hide the header
            example:
            step 1: user scrolls down: curDirection 2, prevDirection 0 > hide header
            step 2: user scrolls down again: curDirection 2, prevDirection 2 > already hidden, do nothing
            step 3: user scrolls up: curDirection 1, prevDirection 2 > show header
            */

            var header = document.getElementById('megaheader');
            var toggled;
            var downThreshold = 800;
            var upThreshold = 400;
            var checkScroll = function () {
                curScroll = w.scrollY || doc.scrollTop;
                if (curScroll > prevScroll) {
                    // scrolled down
                    curDirection = 2;
                }
                else {
                    //scrolled up
                    curDirection = 1;
                }

                if (curDirection !== prevDirection) {
                    toggled = toggleHeader();
                } else {
                    lastY = curScroll
                }

                prevScroll = curScroll;
                if (toggled) {
                    prevDirection = curDirection;
                }
            };

            var toggleHeader = function () {
                toggled = true;
                if (curDirection === 2 && (curScroll - lastY) > downThreshold) {
                    lastY = curScroll
                    header.classList.add('hide');
                    handleBlurScrollUp();
                }
                else if (curDirection === 1 && (lastY - curScroll) > upThreshold) {
                    lastY = curScroll
                    header.classList.remove('hide');
                    handleBlurScrollDown();
                }
                else {
                    toggled = false;
                }
                return toggled;
            };

            window.addEventListener('scroll', checkScroll);

            if (header && header.classList.contains('mininav')) {
                adjustMainMarginTop('80px');
            }
        })();

        var searchBtn = document.querySelector('#search-button');
        if (searchBtn) {
            searchBtn.addEventListener('click', function () {
                window.setTimeout(function () { document.querySelector('#SearchKeywordsDesktop').focus() }, 0);
            });
        }

        $(window).on('changed.zf.mediaquery load', function (event, newSize, oldSize) {
            if (!newSize) {
                newSize = Foundation.MediaQuery.current;
            }

            $(document).off('click.search');

            if (newSize == "large" || newSize == "xlarge" || newSize == "xxlarge") {
                // Large and above screen sizes
                $('#search-button').show();
                $('.search-container form').hide();

                $(document).on('click.search', function (event) {
                    if (!$(event.target).closest('.search-container').length) {
                        $('.search-container form')
                            .hide()
                            .css('border-bottom', 'none');
                        $('#search-button').show();
                    }
                });

                $(document).on('click.search', '#search-button', function (event) {
                    $('.search-container form')
                        .show()
                        .css('border-bottom', '2px solid #25252c');
                    $('#search-button').hide();
                });
            } else {
                // Medium and small screen sizes
                $('.search-container form').show();
                $('#search-button').hide();

                // Clean up only the events specific to the search functionality
                $(document).off('click.search');
            }
        });

        //Background blur for desktop menu
        $('#navigation > ul').on('show.zf.dropdownMenu', function () {
            window.oneadvanced.megaheader.modal.classList.add('is-active');
        });

        //Background blur for mobile menu
        $('.menu-custom-icon').on('click', function () {
            window.oneadvanced.megaheader.modal.classList.add('is-active');
        });

        //Background blur removal for desktop menu
        //the hide.zf.dropdownMenu event fires on any UL regardless of the $targeting below so add extra checks for which UL is closed
        $('#navigation > ul').on('hide.zf.dropdownMenu', function () {
            var $navul = $('#navigation').find('ul.menu.submenu.is-dropdown-submenu.first-sub.vertical');
            // make sure it's not the inner UL inside the nav being closed (what the problem was flagged for)
            if (!$navul.hasClass('second-column')) {
                // if it is in fact the outer largest nav UL, then check if it has lost its -active class or not
                if ($navul.hasClass('js-dropdown-active')) {
                    window.oneadvanced.megaheader.modal.classList.add('is-active');
                } else {
                    window.oneadvanced.megaheader.modal.classList.remove('is-active');
                }
            }
        });

        $(window).on('changed.zf.mediaquery load', function (event, newSize, oldSize) {
            if (!newSize) {
                newSize = Foundation.MediaQuery.current;
            }

            if (newSize == "medium" || newSize == "small") {
                $('.js-drilldown-back').each(function () {
                    var isFirstChild = $(this).parent().closest('.is-drilldown-submenu-parent').parent().closest('.is-drilldown-submenu-parent').length === 0;
                    var backTxt = 'Back to&nbsp;';

                    if (isFirstChild) {
                        backTxt += '<span class="bold-text">Main Menu</span>';
                    } else {
                        var grandparentMenuItem = $(this).parent().closest('.is-drilldown-submenu-parent').parent().closest('.is-drilldown-submenu-parent').find('> a');
                        if (grandparentMenuItem.length) {
                            backTxt += '<span class="bold-text">' + grandparentMenuItem.text() + '</span>';
                        } else {
                            backTxt = 'Back';
                        }
                    }

                    $(this).find('a').html(backTxt);
                });
            }

        })

        //Background blur removal for mobile menu
        $('.close-icon').on('click', function () {
            window.oneadvanced.megaheader.modal.classList.remove('is-active');
        });
    }
    window.oneadvanced.megaheader.hasLoaded = true;
})();